import React from 'react';
import PropTypes from 'prop-types';
import { Box, Card, CardContent, Typography } from '@mui/material';
import TrendingUp from '@mui/icons-material/TrendingUp';
import Money from '@mui/icons-material/Money';
import AccountBalance from '@mui/icons-material/AccountBalance';
import CalendarToday from '@mui/icons-material/CalendarToday';
import { LoadingWrapper } from '../loading';
import useResponsive from '../../hooks/useResponsive';

const TeamsStatsCards = ({ stats, isLoading }) => {
  const mdUp = useResponsive('up', 'md');

  return (
    <LoadingWrapper
      isLoading={isLoading}
      loadingType="skeleton"
      skeletonCount={4}
      gridProps={{ xs: 12, sm: 6, md: 3 }}
      containerSx={{ marginY: 3 }}
    >
      <Box display={mdUp ? 'flex' : ''} gap={2} marginY={3}>
        <Card sx={{ minWidth: 200, flex: 1, marginBottom: mdUp ? 0 : 2 }}>
          <CardContent>
            <Box display="flex" alignItems="center">
              <Box
                sx={{
                  backgroundColor: 'primary.main',
                  borderRadius: 2,
                  p: 1,
                  mr: 2,
                }}
              >
                <TrendingUp sx={{ color: 'white' }} />
              </Box>
              <Box>
                <Typography variant="h6">{stats.total_teams || 0}</Typography>
                <Typography variant="body2" color="textSecondary">
                  Total Teams
                </Typography>
              </Box>
            </Box>
          </CardContent>
        </Card>

        <Card sx={{ minWidth: 200, flex: 1, marginBottom: mdUp ? 0 : 2 }}>
          <CardContent>
            <Box display="flex" alignItems="center">
              <Box
                sx={{
                  backgroundColor: 'success.main',
                  borderRadius: 2,
                  p: 1,
                  mr: 2,
                }}
              >
                <Money sx={{ color: 'white' }} />
              </Box>
              <Box>
                <Typography variant="h6">{stats.total_employees || 0}</Typography>
                <Typography variant="body2" color="textSecondary">
                  Total Employees
                </Typography>
              </Box>
            </Box>
          </CardContent>
        </Card>

        <Card sx={{ minWidth: 200, flex: 1, marginBottom: mdUp ? 0 : 2 }}>
          <CardContent>
            <Box display="flex" alignItems="center">
              <Box
                sx={{
                  backgroundColor: 'info.main',
                  borderRadius: 2,
                  p: 1,
                  mr: 2,
                }}
              >
                <AccountBalance sx={{ color: 'white' }} />
              </Box>
              <Box>
                <Typography variant="h6">{stats.total_team_leads || 0}</Typography>
                <Typography variant="body2" color="textSecondary">
                  Total Team Leads
                </Typography>
              </Box>
            </Box>
          </CardContent>
        </Card>

        <Card sx={{ minWidth: 200, flex: 1 }}>
          <CardContent>
            <Box display="flex" alignItems="center">
              <Box
                sx={{
                  backgroundColor: 'warning.main',
                  borderRadius: 2,
                  p: 1,
                  mr: 2,
                }}
              >
                <CalendarToday sx={{ color: 'white' }} />
              </Box>
              <Box>
                <Typography variant="h6">{stats.total_supervisors || 0}</Typography>
                <Typography variant="body2" color="textSecondary">
                  Total Supervisors
                </Typography>
              </Box>
            </Box>
          </CardContent>
        </Card>
      </Box>
    </LoadingWrapper>
  );
};

TeamsStatsCards.propTypes = {
  stats: PropTypes.shape({
    total_teams: PropTypes.number,
    total_employees: PropTypes.number,
    total_team_leads: PropTypes.number,
    total_supervisors: PropTypes.number,
  }).isRequired,
  isLoading: PropTypes.bool.isRequired,
};

export default TeamsStatsCards;
